import type { ProfileTag as ProfileTagType } from '@/@types/user'
import { css } from '@emotion/react'
import type { HTMLAttributes } from 'react'

export interface UserProfileTagProps extends HTMLAttributes<HTMLDivElement> {
	data: ProfileTagType
}

export default function UserProfileTag({ data, ...props }: UserProfileTagProps) {
	return (
		<div
			css={css`
				display: flex;
				height: 22px;
				padding: 4px 10px;
				align-items: center;
				gap: 10px;
				border-radius: 20px;
				width: fit-content;
				background: var(--bg-on-body-2, #f0f3f5);

				font-size: 14px;
				line-height: 20px; /* 142.857% */
				white-space: nowrap;

				${data.type === 'MALE_RELATIONSHIP_STATE' || data.type === 'FEMALE_RELATIONSHIP_STATE'
					? css`
							background: ${data.type === 'MALE_RELATIONSHIP_STATE'
								? 'var(--solid-label-male)'
								: 'var(--solid-label-female, rgba(252, 104, 157, 0.5))'};
							color: #fff;
						`
					: css``}
			`}
			{...props}
		>
			{data.picUrl && (
				<img
					src={data.picUrl}
					css={css`
						width: 16px;
						height: 16px;
					`}
				/>
			)}
			{data.text}
		</div>
	)
}
